import React, { useState } from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const CollapsibleText = (props) => {

  const COLLAPSED = {
    class: "read-more",
    label: "Read more"
  }

  const EXPANDED = {
    class: "read-less",
    label: "Read less"
  }

  const DEFAULT_VALUES = {
    class: "",
    label: ""
  }

  const [isCollapsed, setIsCollapsed] = useState(true)

  const isButtonActive = !!props.text && props.text.length > props.maxCharacters

  const handleClick = () => {
    setIsCollapsed(!isCollapsed)
  }

  const getAttributes = () => {
    if (isButtonActive) {
      return isCollapsed ? COLLAPSED : EXPANDED
    }
    return DEFAULT_VALUES
  }

  return (
    <div className={`collapsible-container
                     ${props.classNames.container}
                     ${getAttributes().class}`}>
      <span className={`collapsible-text ${props.classNames.text}`}>
        {props.text || ""}
      </span>
      <button
        onClick={handleClick}
        style={{color: props.themeColorHex}}>
        {getAttributes().label}
      </button>
    </div>
  )
}

CollapsibleText.propTypes = {
  classNames: PropTypes.object.isRequired,
  text: PropTypes.string,
  maxCharacters: PropTypes.number,
  themeColorHex: PropTypes.string
}

CollapsibleText.defaultProps = {
  maxCharacters: 100
}

export default CollapsibleText
